import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  REPORT_HEADCOUNT_GET_REQUEST,
  REPORT_HEADCOUNT_GET_SUCCESS,
  REPORT_HEADCOUNT_GET_FAILURE,
  REPORT_HEADCOUNT_GET_RESET,
  REPORT_YEAR_OF_SERVICE_GET_REQUEST,
  REPORT_YEAR_OF_SERVICE_GET_SUCCESS,
  REPORT_YEAR_OF_SERVICE_GET_FAILURE,
  REPORT_YEAR_OF_SERVICE_GET_RESET,
  REPORT_LEAVE_HISTORY_GET_REQUEST,
  REPORT_LEAVE_HISTORY_GET_SUCCESS,
  REPORT_LEAVE_HISTORY_GET_FAILURE,
  REPORT_LEAVE_HISTORY_GET_RESET,
  REPORT_ACTIVE_USERS_GET_REQUEST,
  REPORT_ACTIVE_USERS_GET_SUCCESS,
  REPORT_ACTIVE_USERS_GET_FAILURE,
  REPORT_ACTIVE_USERS_GET_RESET,
  REPORT_YEAR_OF_SERVICE_EXPORT_REQUEST,
  REPORT_YEAR_OF_SERVICE_EXPORT_SUCCESS,
  REPORT_YEAR_OF_SERVICE_EXPORT_FAILURE,
  REPORT_YEAR_OF_SERVICE_EXPORT_RESET,
  REPORT_HEADCOUNT_EXPORT_REQUEST,
  REPORT_HEADCOUNT_EXPORT_SUCCESS,
  REPORT_HEADCOUNT_EXPORT_FAILURE,
  REPORT_HEADCOUNT_EXPORT_RESET,
  REPORT_LEAVE_HISTORY_EXPORT_REQUEST,
  REPORT_LEAVE_HISTORY_EXPORT_SUCCESS,
  REPORT_LEAVE_HISTORY_EXPORT_FAILURE,
  REPORT_LEAVE_HISTORY_EXPORT_RESET,
  REPORT_ACTIVE_USERS_EXPORT_REQUEST,
  REPORT_ACTIVE_USERS_EXPORT_SUCCESS,
  REPORT_ACTIVE_USERS_EXPORT_FAILURE,
  REPORT_ACTIVE_USERS_EXPORT_RESET,
  REPORT_AUDIT_LOGS_EXPORT_REQUEST,
  REPORT_AUDIT_LOGS_EXPORT_SUCCESS,
  REPORT_AUDIT_LOGS_EXPORT_FAILURE,
  REPORT_AUDIT_LOGS_EXPORT_RESET,
  REPORT_SUBCONTRACT_EXPORT_REQUEST,
  REPORT_SUBCONTRACT_EXPORT_SUCCESS,
  REPORT_SUBCONTRACT_EXPORT_FAILURE,
  REPORT_SUBCONTRACT_EXPORT_RESET,
  REPORT_COMPENSATE_EXPORT_REQUEST,
  REPORT_COMPENSATE_EXPORT_SUCCESS,
  REPORT_COMPENSATE_EXPORT_FAILURE,
  REPORT_COMPENSATE_EXPORT_RESET,
  REPORT_COMPENSATE_GET_REQUEST,
  REPORT_COMPENSATE_GET_SUCCESS,
  REPORT_COMPENSATE_GET_FAILURE,
  REPORT_COMPENSATE_GET_RESET,
  REPORT_COMPENSATE_CANCEL_REQUEST,
  REPORT_COMPENSATE_CANCEL_SUCCESS,
  REPORT_COMPENSATE_CANCEL_FAILURE,
  REPORT_COMPENSATE_CANCEL_RESET,
  REPORT_LEAVE_GENERATION_GET_REQUEST,
  REPORT_LEAVE_GENERATION_GET_SUCCESS,
  REPORT_LEAVE_GENERATION_GET_FAILURE,
  REPORT_LEAVE_GENERATION_GET_RESET,
  REPORT_SUBCONTRACT_GET_REQUEST,
  REPORT_SUBCONTRACT_GET_SUCCESS,
  REPORT_SUBCONTRACT_GET_FAILURE,
  REPORT_SUBCONTRACT_GET_RESET,
} from './../../constants'

export function getHeadcountReport(lob_id = '', start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/head-counts-2/?${lob_id === '' ? '' : `lob_id=${lob_id}&`}start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_HEADCOUNT_GET_REQUEST,
        REPORT_HEADCOUNT_GET_SUCCESS,
        REPORT_HEADCOUNT_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getYearOfServiceReport(date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/year-of-services?date=${date}`,
      method: 'GET',
      types: [
        REPORT_YEAR_OF_SERVICE_GET_REQUEST,
        REPORT_YEAR_OF_SERVICE_GET_SUCCESS,
        REPORT_YEAR_OF_SERVICE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getLeaveHistoryReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-historys?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_LEAVE_HISTORY_GET_REQUEST,
        REPORT_LEAVE_HISTORY_GET_SUCCESS,
        REPORT_LEAVE_HISTORY_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getActiveUsersReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/audit-logs/active-user?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_ACTIVE_USERS_GET_REQUEST,
        REPORT_ACTIVE_USERS_GET_SUCCESS,
        REPORT_ACTIVE_USERS_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getCompensateReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates/report?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_COMPENSATE_GET_REQUEST,
        REPORT_COMPENSATE_GET_SUCCESS,
        REPORT_COMPENSATE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function cancelCompensateReport(requestID, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates/cancel/${requestID}`,
      method: 'POST',
      types: [
        REPORT_COMPENSATE_CANCEL_REQUEST,
        REPORT_COMPENSATE_CANCEL_SUCCESS,
        REPORT_COMPENSATE_CANCEL_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function getSubcontractReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_SUBCONTRACT_GET_REQUEST,
        REPORT_SUBCONTRACT_GET_SUCCESS,
        REPORT_SUBCONTRACT_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getLeaveGenerationReport(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-generations/`,
      method: 'GET',
      types: [
        REPORT_LEAVE_GENERATION_GET_REQUEST,
        REPORT_LEAVE_GENERATION_GET_SUCCESS,
        REPORT_LEAVE_GENERATION_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportActiveUsersReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/audit-logs/active-user/exports?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_ACTIVE_USERS_EXPORT_REQUEST,
        REPORT_ACTIVE_USERS_EXPORT_SUCCESS,
        REPORT_ACTIVE_USERS_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportAuditLogsReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/audit-logs/exports/?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_AUDIT_LOGS_EXPORT_REQUEST,
        REPORT_AUDIT_LOGS_EXPORT_SUCCESS,
        REPORT_AUDIT_LOGS_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportLeaveHistoryReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-historys/exports?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_LEAVE_HISTORY_EXPORT_REQUEST,
        REPORT_LEAVE_HISTORY_EXPORT_SUCCESS,
        REPORT_LEAVE_HISTORY_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportHeadcountReport(lob_id = '', start_date, end_date, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/head-counts-2/export?${lob_id === '' ? '' : `lob_id=${lob_id}&`}start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_HEADCOUNT_EXPORT_REQUEST,
        REPORT_HEADCOUNT_EXPORT_SUCCESS,
        REPORT_HEADCOUNT_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportYearOfServiceReport(date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/year-of-services/exports?date=${date}`,
      method: 'GET',
      types: [
        REPORT_YEAR_OF_SERVICE_EXPORT_REQUEST,
        REPORT_YEAR_OF_SERVICE_EXPORT_SUCCESS,
        REPORT_YEAR_OF_SERVICE_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportSubcontractReport(start_date = '', end_date = '', access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost/exports?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_SUBCONTRACT_EXPORT_REQUEST,
        REPORT_SUBCONTRACT_EXPORT_SUCCESS,
        REPORT_SUBCONTRACT_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportCompensateReport(start_date, end_date, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates/exports?start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
      types: [
        REPORT_COMPENSATE_EXPORT_REQUEST,
        REPORT_COMPENSATE_EXPORT_SUCCESS,
        REPORT_COMPENSATE_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetHeadcountReport() {
  return {
    type: REPORT_HEADCOUNT_GET_RESET,
  }
}
export function resetGetYearOfServiceReport() {
  return {
    type: REPORT_YEAR_OF_SERVICE_GET_RESET,
  }
}
export function resetGetLeaveHistoryReport() {
  return {
    type: REPORT_LEAVE_HISTORY_GET_RESET,
  }
}
export function resetGetActiveUsersReport() {
  return {
    type: REPORT_ACTIVE_USERS_GET_RESET,
  }
}
export function resetGetCompensateReport() {
  return {
    type: REPORT_COMPENSATE_GET_RESET,
  }
}
export function resetCancelCompensateReport() {
  return {
    type: REPORT_COMPENSATE_CANCEL_RESET,
  }
}
export function resetGetSubcontractReport() {
  return {
    type: REPORT_SUBCONTRACT_GET_RESET,
  }
}
export function resetGetLeaveGenerationReport() {
  return {
    type: REPORT_LEAVE_GENERATION_GET_RESET,
  }
}
export function resetExportActiveUsersReport() {
  return {
    type: REPORT_ACTIVE_USERS_EXPORT_RESET,
  }
}
export function resetExportAuditLogsReport() {
  return {
    type: REPORT_AUDIT_LOGS_EXPORT_RESET,
  }
}
export function resetExportLeaveHistoryReport() {
  return {
    type: REPORT_LEAVE_HISTORY_EXPORT_RESET,
  }
}
export function resetExportHeadcountReport() {
  return {
    type: REPORT_HEADCOUNT_EXPORT_RESET,
  }
}
export function resetExportYearOfServiceReport() {
  return {
    type: REPORT_YEAR_OF_SERVICE_EXPORT_RESET,
  }
}
export function resetExportSubcontractReport() {
  return {
    type: REPORT_SUBCONTRACT_EXPORT_RESET,
  }
}
export function resetExportCompensateReport() {
  return {
    type: REPORT_COMPENSATE_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/report/report-action.js